import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPeople } from "redux/KPIs/peopleSlice";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Input, Label, Collapse } from "reactstrap";
import toast from "react-hot-toast";

import { createTeam } from "components/Apis/teams";
import { updateBonusResultTeam, updateBonusResult } from "components/Apis/KPIs";
import { deleteTeam } from "components/Apis/teams";
import { modifyTeam } from "components/Apis/teams";
import { currencyFormatter, parseCurrency } from "../helpers";
import { NoTeamLabel } from "views/KPIs";

const Goals = () => {

    const people = useSelector((state) => state.KPIPeopleReducer.people);
    const quarter = useSelector((state) => state.KPIFilterReducer.quarter);
    const [teamMembersShown, setTeamMembersShown] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        if (quarter) {
            dispatch(fetchPeople(quarter));
        }
    }, [quarter, dispatch]);

    // Team creation modal
    const [teamCreateionModalOpen, setTeamCreationModalModal] = useState(false);
    const toggleCreationModal = () => setTeamCreationModalModal(!teamCreateionModalOpen);

    const TeamCreateModal = () => {
        const [teamName, setTeamName] = useState(null);

        return (
            <Modal isOpen={teamCreateionModalOpen} toggle={toggleCreationModal}>
                <ModalHeader className="bg-dark text-white text-center p-3 fw-bold" toggle={toggleCreationModal}>
                    Create A New Team
                </ModalHeader>
                <ModalBody className="m-0 mt-1 p-1">
                    <Row>
                        <Col>
                            <div className="p-2">
                                <Label for="teamName">Team Name</Label>
                                <Input
                                    id="teamName"
                                    placeholder="Enter Team Name"
                                    onChange={(e) => setTeamName(e.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn bg-danger text-white border-0" onClick={toggleCreationModal}>
                        Close
                    </Button>
                    <Button
                        className="btn bg-success text-white border-0"
                        onClick={() => {
                            if (teamName) {
                                createTeam(teamName, quarter);
                                toggleCreationModal();
                                setTimeout(() => {
                                    dispatch(fetchPeople(quarter));
                                }, 300);
                            } else {
                                toast.error("Team name required");
                            }
                        }}
                    >
                        Create Team
                    </Button>
                </ModalFooter>
            </Modal>
        );
    };

    const onDragEnd = async (result) => {
        const { source, destination, draggableId } = result;
        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }
        if (destination.droppableId === source.droppableId) {
            return;
        }
        await updateBonusResultTeam(
            {
                ...quarter, // quarter to update results for
                name: draggableId, // person moved
            },
            destination.droppableId // target team id
        );
        dispatch(fetchPeople(quarter));
        // Show team members after a person is moved to the team
        if (!teamMembersShown[destination.droppableId]) {
            setTeamMembersShown({ ...teamMembersShown, [destination.droppableId]: true });
        }
    };

    return (
        <>
            <TeamCreateModal />
            <DragDropContext onDragEnd={onDragEnd}>
                <div className="table-header kpi-section">
                    <h1>
                        Load Count Goals
                    </h1>
                </div>
                <table className="kpis-goals-table w-100">
                    <thead>
                        <tr>
                            <th style={{ width: "50%" }}>Name</th>
                            <th style={{ width: "50%" }}>Load Count Goal</th>
                        </tr>
                    </thead>
                    {people &&
                        people.map((team, index) => (
                            <Droppable key={team.id} droppableId={team.id}>
                                {(provided) => (
                                    <>
                                        <tbody
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            <tr
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={`kpi-goals-team-row ${team.name === NoTeamLabel ? 'company-row' : ''}`}
                                            >
                                                <td>
                                                    <div className="team-name">
                                                        {`[${team.members.length}] ${team.name}`}
                                                    </div>
                                                </td>
                                                <td className="row">
                                                    <div className={`score-cell col ${team.name === NoTeamLabel ? "company-row" : ""}`}>
                                                        <>{team.invoice_count_goal}</>
                                                    </div>
                                                    <div className="actions-cell col-6">
                                                        {team.name === NoTeamLabel ? (
                                                            <>
                                                                {/* <button className="new-row-btn" onClick={toggleCreationModal}>
                                                                    <div className="sign">+</div>
                                                                    <div className="text">Add New Team</div>
                                                                </button> */}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {/* <button
                                                                    className="btn-xs action-btn btn-delete"
                                                                    onClick={() => {
                                                                        deleteTeam(team.id);
                                                                        setTimeout(() => {
                                                                            dispatch(fetchPeople( quarter ));
                                                                        }, 300);
                                                                    }}
                                                                    title="Delete"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button> */}
                                                            </>
                                                        )}
                                                        <button
                                                            className="btn-xs action-btn btn-collapse"
                                                            onClick={() => {
                                                                setTeamMembersShown({
                                                                    ...teamMembersShown,
                                                                    [team.id]: !teamMembersShown[team.id],
                                                                });
                                                            }}
                                                            title="Toggle Members"
                                                        >
                                                            {teamMembersShown[team.id] ? (
                                                                <i className="fa fa-chevron-up"></i>) :
                                                                <i className="fa fa-chevron-down"></i>
                                                            }
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" className="p-0">
                                                    <Collapse isOpen={teamMembersShown[team.id]}>
                                                        <table className="w-100">
                                                            <tbody>
                                                                {team.members.map((person, index) => (
                                                                    <Draggable key={person.name} draggableId={String(person.name)} index={index}>
                                                                        {(provided) => (
                                                                            <tr
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                            >
                                                                                <td style={{ width: "50%" }}>{person.name}</td>
                                                                                <td style={{ width: "50%" }}>
                                                                                    <input
                                                                                        className="kpi-input"
                                                                                        defaultValue={person.kpi_invoice_count_goal}
                                                                                        onBlur={(e) => {
                                                                                            const value = e.target.value;
                                                                                            // Check if the value contains non-digit characters
                                                                                            if (!/^\d*$/.test(value)) {
                                                                                                // Show error toast if the value is invalid
                                                                                                toast.error("Goal may only contain integers!");
                                                                                            } else {
                                                                                                // Call the API if the value is valid
                                                                                                updateBonusResult(
                                                                                                    {
                                                                                                        ...quarter,
                                                                                                        name: person.name,
                                                                                                    },
                                                                                                    { kpi_invoice_count_goal: value }
                                                                                                );
                                                                                                setTimeout(() => {
                                                                                                    dispatch(fetchPeople(quarter));
                                                                                                }, 300);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </Collapse>
                                                </td>
                                            </tr>
                                            {provided.placeholder}
                                        </tbody>
                                    </>
                                )}
                            </Droppable>
                        ))}
                </table>
            </DragDropContext>
            <br />
            <div className="table-header kpi-section">
                <h1>
                    Team Revenue Goals
                </h1>
            </div>
            <table className='kpis-goals-table mt-3'>
                <thead>
                    <tr>
                        <th>Team</th>
                        <th>Revenue Goal</th>
                        <th>Gross Profit Goal</th>
                        <th>Act.</th>
                    </tr>
                </thead>
                <tbody>
                    {people.length > 0 && people.map((team, index) => (
                        <tr key={index} className={`kpi-team-row ${team.name === NoTeamLabel ? 'company-row' : ''}`}>
                            <td style={{ fontWeight: 'bold' }}>
                                {`[${team.members.length}] ${team.name}`}
                            </td>
                            <td>
                                {team.name === NoTeamLabel ? (
                                    <>
                                        {currencyFormatter.format(team.revenue_goal)}
                                    </>
                                ) : (
                                    <input
                                        className="kpi-input"
                                        defaultValue={currencyFormatter.format(team.revenue_goal)}
                                        onBlur={(e) => {
                                            const formattedValue = parseCurrency(e.target.value);
                                            const value = parseFloat(formattedValue);

                                            if (value === team.revenue_goal) {
                                                return;
                                            }
                                            // Check if the value contains non-digit characters
                                            if (isNaN(value)) {
                                                // Show error toast if the value is invalid
                                                toast.error("Goal may only contain decimals!");
                                            } else {
                                                // Call the API if the value is valid
                                                modifyTeam(
                                                    {
                                                        id: team.id,
                                                        revenue_goal: value
                                                    },
                                                );
                                                setTimeout(() => {
                                                    dispatch(fetchPeople(quarter));
                                                }, 300);
                                            }
                                        }}
                                    />
                                )}
                            </td>
                            <td>
                                {team.name === NoTeamLabel ? (
                                    <>
                                        {currencyFormatter.format(team.gross_profit_goal)}
                                    </>
                                ) : (
                                    <input
                                        className="kpi-input"
                                        defaultValue={currencyFormatter.format(team.gross_profit_goal)}
                                        onBlur={(e) => {
                                            const formattedValue = parseCurrency(e.target.value);
                                            const value = parseFloat(formattedValue);

                                            if (value === team.gross_profit_goal) {
                                                return;
                                            }
                                            // Check if the value contains non-digit characters
                                            if (isNaN(value)) {
                                                // Show error toast if the value is invalid
                                                toast.error("Goal may only contain decimals!");
                                            } else {
                                                // Call the API if the value is valid
                                                modifyTeam(
                                                    {
                                                        id: team.id,
                                                        gross_profit_goal: value
                                                    },
                                                );
                                                setTimeout(() => {
                                                    dispatch(fetchPeople(quarter));
                                                }, 300);
                                            }
                                        }}
                                    />
                                )}
                            </td>
                            <td style={{ width: '2%' }}>
                                <div className='actions-cell'>
                                    {team.name === NoTeamLabel ? (
                                        <>
                                            {/* <button className="new-row-btn" onClick={toggleCreationModal}>
                                                <div className="sign">+</div>
                                                <div className="text">Add New Team</div>
                                            </button> */}
                                        </>
                                    ) : (
                                        <button
                                            className="btn-xs action-btn btn-delete"
                                            onClick={() => {
                                                deleteTeam(team.id);
                                                setTimeout(() => {
                                                    dispatch(fetchPeople(quarter));
                                                }, 300);
                                            }}
                                            title="Delete"
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={3} style={{ textAlign: 'center' }}>
                            <button className="new-row-btn" onClick={toggleCreationModal}>
                                <div className="sign">+</div>
                                <div className="text">Add New Team</div>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default Goals;